import MainStore from './main.store';

const mainStore = new MainStore();


export default {
  mainStore
}



// WEBPACK FOOTER //
// ./src/stores/index.js